import { FC, useState, useEffect } from "react";
import Navbar from "../Navbar";
import { Box, useMediaQuery, SxProps, Theme } from "@mui/material";

import MobileFilterBar from "../MobileHomePageFilterBar/MobileHomePageFilterBar";
import { LargeFilterBar } from "../LargeFilterBar";
import OptimizedImage from "../OptimizedImage";

// Import hero images as assets - using WebP for better performance
import hero1 from "../../assets/public/hero/desktop1.webp";
import hero3 from "../../assets/public/hero/desktop3.webp";
import hero5 from "../../assets/public/hero/mobile2.webp";
import heroMobile from '../../assets/public/hero/mobile5.webp'

import "./Header.scss";

interface Props {
  sx?: SxProps<Theme>;
}

const Header: FC<Props> = ({ sx }) => {
  const imagesDesktop = [
    {
      component: hero1,
      placement: "bottom 0px right 0px",
    },
    {
      component: hero3,
      placement: "top 0px right 0px",
    },
  ];
  const imagesMobile = [
    // {
    //   component: heroMobile,
    //   placement: "bottom -60px left 50%",
    // },
    {
      component: hero5,
      placement: "bottom -40px left 50%",
    },
  ];

  const [mobileImage, setMobileImage] = useState<any>({});
  const [desktopImage, setDesktopImage] = useState<any>({});

  const isMobile = useMediaQuery("(max-width:900px)");

  useEffect(() => {
    setMobileImage(
      imagesMobile[Math.floor(Math.random() * imagesMobile.length)]
    );
    setDesktopImage(
      imagesDesktop[Math.floor(Math.random() * imagesDesktop.length)]
    );
  }, []);

  return (
    <Box
      sx={{
        width: "100%",
        minHeight: { xs: "0px" },
        height: { xs: "560px", sm: "100%" },
        display: "flex",
        justifyContent: "start",
        flexDirection: "column",
        top: 0,
        left: 0,
        ...sx,
      }}
      className="header-wrapper"
    >
      <Navbar />
      <Box
        className="filter-bar-wrapper"
        sx={{
          position: "relative",
          width: "100%",
          height: "100%",
        }}
      >
        <OptimizedImage
          src={isMobile ? mobileImage.component : desktopImage.component}
          alt="Romingo Splash Image"
          width={1920}
          height={1080}
          priority={true}
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            objectFit: "cover",
            objectPosition: isMobile
              ? mobileImage.placement
              : desktopImage.placement,
            zIndex: -1,
          }}
        />

        <Box
          sx={{
            ml: { xs: "1em", sm: "1.5em", md: "1.5em", lg: "0em" },
            mt: { xs: "4.5em", sm: "8em", md: "9em", lg: "9em" },
            mb: { xs: "0em", sm: "0em", md: "0em", lg: "2em" },
          }}
        >
          {isMobile && (
            <Box sx={{}}>
              <Box
                sx={{ textAlign: { xs: "left", sm: "left" }, px: { xs: "0.75rem", sm: '0.25rem', md: '0' } }}
                className="filter-bar-wrapper-title"
              >
                <h1 style={{ fontSize: '1.70rem' }}>
                  <b>Pet-friendly travel starts here</b>
                </h1>
                <h2></h2>
              </Box>
              <Box
                sx={{
                  fontSize: { xs: "12px", sm: "14px", md: "16px", lg: "18px" },
                  textAlign: { xs: "left", sm: "left" },
                  pl: { xs: '0.75rem', sm: '0.25rem', md: '0' }
                }}
                className="filter-bar-wrapper-desc"
              >
                Book pet friendly hotels, vacation rentals, and resorts at the lowest rates
              </Box>
            </Box>
          )}
        </Box>

        {isMobile && (
          <Box sx={{}}>
            <MobileFilterBar />
          </Box>
        )}
        {!isMobile && (
          <Box
            sx={{
              display: { xs: "none", md: "block" },
            }}
          >
            <LargeFilterBar showText={true} />
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default Header;
